import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const EnquiryPage = () => {
    const [formData, setFormData] = useState({
        name: '', phone: '', email: '', service: '', message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            // 1. Django backend ko hit karein taaki database mein save ho jaye
            await axios.post('/api/enquiry/', formData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            // 2. Direct Browser se Brevo API Call (cPanel restrictions bypass karne ke liye)
            const url = "https://api.brevo.com/v3/smtp/email";
            const apiKey = "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";

            const messageBody = `You have received a new enquiry on Raj Kuruma Enterprises:\n\nName: ${formData.name}\nPhone: ${formData.phone}\nEmail: ${formData.email}\nService: ${formData.service}\nMessage: ${formData.message}`;

            const payload = {
                sender: { email: "contact@rajkurumaenterprises.com", name: "Raj Kuruma Enterprises" },
                to: [{ email: "rajkurumaenterprises@gmail.com", name: "rajkurumaenterprises" }],
                subject: `New Enquiry: ${formData.service} from ${formData.name}`,
                textContent: messageBody
            };

            await fetch(url, {
                method: "POST",
                headers: {
                    "accept": "application/json",
                    "api-key": apiKey,
                    "content-type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            setSuccessMessage("Enquiry Submitted Successfully! Notification sent to email & saved in Admin Panel.");
            setFormData({ name: '', phone: '', email: '', service: '', message: '' });
        } catch (error) {
            console.error("Submission Error:", error);
            setErrorMessage("Failed to submit. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen">
            <Navbar />
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="relative h-[350px] w-full bg-cover bg-center flex items-center justify-center text-white" style={{ backgroundImage: "url('/about-banner.jpg')" }}>
                <div className="absolute inset-0 bg-black/50" />
                <h1 className="relative text-5xl font-bold z-10">Enquiry Now</h1>
            </motion.div>

            <div className="max-w-3xl mx-auto px-6 py-20">
                <motion.div initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} className="bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
                    <h2 className="text-3xl font-bold mb-8 text-[#1a2b4d] text-center">Send Us Your Requirement</h2>

                    {successMessage && (
                        <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-sm text-center font-medium">
                            {successMessage}
                        </div>
                    )}

                    {errorMessage && (
                        <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-sm text-center font-medium">
                            {errorMessage}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid md:grid-cols-2 gap-6">
                            <input name="name" onChange={handleChange} value={formData.name} type="text" placeholder="Full Name" className="w-full p-4 border border-gray-300 rounded-sm focus:ring-2 focus:ring-[#f15a24] outline-none" required />
                            <input name="phone" onChange={handleChange} value={formData.phone} type="tel" placeholder="Phone Number" className="w-full p-4 border border-gray-300 rounded-sm focus:ring-2 focus:ring-[#f15a24] outline-none" required />
                        </div>
                        <input name="email" onChange={handleChange} value={formData.email} type="email" placeholder="Email Address" className="w-full p-4 border border-gray-300 rounded-sm focus:ring-2 focus:ring-[#f15a24] outline-none" required />

                        <select name="service" onChange={handleChange} value={formData.service} className="w-full p-4 border border-gray-300 rounded-sm bg-white focus:ring-2 focus:ring-[#f15a24] outline-none" required>
                            <option value="">Select Service</option>
                            <option value="Cab Services">Cab Services</option>
                            <option value="Real Estate Services">Real Estate Services</option>
                            <option value="Business Setup Services">Business Setup Services</option>
                            <option value="Packers & Movers">Packers & Movers</option>
                            <option value="Company Registration">Company Registration</option>
                            <option value="Compliance & Government Approvals">Compliance & Government Approvals</option>
                            <option value="Organic Magnetic Pyrolysis System">Organic Magnetic Pyrolysis System</option>
                            <option value="JLPT Course (Agra)">JLPT Course (Agra)</option>
                        </select>

                        <textarea name="message" onChange={handleChange} value={formData.message} placeholder="Your Message" rows="5" className="w-full p-4 border border-gray-300 rounded-sm focus:ring-2 focus:ring-[#f15a24] outline-none"></textarea>

                        <button type="submit" disabled={isSubmitting} className="w-full bg-[#f15a24] text-white py-4 font-bold text-lg hover:bg-[#d44d1e] transition shadow-lg rounded-sm uppercase tracking-wider">
                            {isSubmitting ? 'Sending...' : 'Submit Enquiry'}
                        </button>
                    </form>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default EnquiryPage;